import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros'
import { switchCardEstado } from "../../../helper/publicacionHelper";
import './PublicacionStyles.css';

export default class PublicacionListItem extends Component {
    render = () => {
        const {
            idPublicacion,
            titulo,
            skuSeller,
            skuMarket,
            categoria,
            precioLista,
            precioPromocional,
            estado,
            img,
            marca,
            envioGratis,
            handleEstado,
            tipoEntrega,
            fechaPublicacion,
            descripcionSeller,
            tipoPublicacion,
            stock,
            isAdminOrCategory,
            productoExceptuado,
            onOrdenes,
            hideCheckboxEstado,
            hideBtnOrdenes,
            descripcionUmbralStock
        } = this.props;

        // Aseguramos que sean strings para evitar error de React
        const marcaStr = typeof marca === 'object' && marca !== null ? (marca.nombre ?? JSON.stringify(marca)) : marca;
        const categoriaStr = typeof categoria === 'object' && categoria !== null ? (categoria.nombre ?? JSON.stringify(categoria)) : categoria;
        const tipoPublicacionStr = typeof tipoPublicacion === 'object' && tipoPublicacion !== null ? (tipoPublicacion.nombre ?? JSON.stringify(tipoPublicacion)) : tipoPublicacion;

        // Si el estado es número, lo convertimos a string
        let estadoStr = estado;
        if (estado === 1) {
            estadoStr = "activo";
        } else if (typeof estado === 'number') {
            // Importar el helper
            // eslint-disable-next-line
            const { getEstadoPublicacionFromId } = require("../../../helper/publicacionHelper");
            estadoStr = getEstadoPublicacionFromId(estado);
        }
        // Si el estado es string, lo convertimos a id
        let estadoId = estado;
        if (typeof estado === 'string') {
            // Importar el helper
            // eslint-disable-next-line
            const { getIdEstadoPublicacion } = require("../../../helper/publicacionHelper");
            estadoId = getIdEstadoPublicacion(estado);
        }
        const { text, color } = switchCardEstado(estadoId);

        let labelEstado =
            <div>
                <span className={`label label-item label-${color}`}>{text}</span>
            </div>
            ;

        let checkboxEstado =
            <div
                className="custom-control form-switch"
                onClick={(e) => handleEstado(e, { idPublicacion: idPublicacion, estado: estado, skuSeller: skuSeller, stock: stock })}
            >
                <input
                    id={idPublicacion}
                    type="checkbox"
                    className="form-check-input"
                    defaultChecked={estado === "activo"}
                />
                <label htmlFor={idPublicacion} className="custom-control-label text-capitalize d-block">
                    <span className={`label label-item label-${color}`}>{text}</span>
                </label>
            </div>
            ;


        let btnOrdenes =
            <div className='mt-2 font-14 applyFont'>
                <a
                    onClick={(e) => onOrdenes(e, this.props.skuMarket)}
                    className="sl-icon-basket text-decoration-none fs-6 color-rojo-megatone me-1"
                >
                </a>
                Ordenes
            </div >
            ;



        return (
            <div className="list-group-item hover-background-color bg-white border border-light">
                <div className="row p-2 align-items-center">

                    <div className="col-8 col-md-2 text-center text-break">
                        <div className="displayInlineTable">
                            <h6 className="font-weight-bold">{descripcionSeller}</h6>
                            <span className="font-size-072rem">{fechaPublicacion ? fechaPublicacion.substr(0, 10) : ""}</span>
                            <br></br><span className="font-size-072rem">{idPublicacion}</span>
                        </div>
                    </div>

                    <div className="col-4 col-md-1 text-center">
                        <img className="mw-60px" alt={titulo.substring(0, 10) + "..."} src={img} />
                    </div>

                    <div className="col-12 col-md-9 p-md-0 p-4">
                        <div className="row px-1">

                            <div className="col-12">
                                <h6 className="box-title m-b-5 font-weight-bold">{titulo}</h6>
                            </div>

                            <div className="col-12 col-md-6 pb-lg-0 pb-md-0 pb-4">
                                <small className="applyFont">{marcaStr} - {categoriaStr}</small>
                                <small className="d-block mt-1">
                                    SKU Seller: {skuSeller} | SKU Market: {skuMarket}
                                </small>
                                <small className="d-block mt-1">
                                    <b>Tipo publicación: </b>{tipoPublicacionStr}
                                </small>
                                <div className="mt-1">
                                    {/* Lógica de Stock Custom */}
                                    {(() => {
                                        let stockClass = "stock-alto";
                                        let stockText = "Stock Alto";

                                        if (stock <= 0) {
                                            stockClass = "sin-stock";
                                            stockText = "Sin Stock";
                                        } else if (descripcionUmbralStock === "Stock Bajo") {
                                            stockClass = "stock-bajo";
                                            stockText = "Stock Bajo";
                                        } else if (descripcionUmbralStock === "Sin Stock") {
                                            // Fallback por si backend manda "Sin Stock" en descripcion pero stock > 0 por error
                                            stockClass = "sin-stock";
                                            stockText = "Sin Stock";
                                        }

                                        return (
                                            <span className={`stock-indicator ${stockClass}`}>
                                                Stock: {stock} - {stockText}
                                            </span>
                                        );
                                    })()}
                                </div>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                <small className="font-14 applyFont">
                                    {tipoEntrega ?? ""}
                                </small>
                                <br />
                                <small className="font-14 applyFont">
                                    {(envioGratis) ? "Envio Gratis" : ""}
                                </small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                <h6 className="font-weight-bold box-title m-b-0">
                                    $ {(precioPromocional) ? formatoDecimal(precioPromocional) : formatoDecimal(precioLista)}
                                </h6>
                                <small className="font-size-10px">Precio Publicado</small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                {/* Si está oculto el switch, muestra solo el label de estado */}
                                {hideCheckboxEstado ? labelEstado : (isAdminOrCategory ? checkboxEstado : labelEstado)}
                                {isAdminOrCategory && productoExceptuado &&
                                    <small className="label label-item label-red mt-1 p-1">
                                        PRODUCTO <br /> EXCEPTUADO
                                    </small>
                                }
                                {/* Oculta el botón de órdenes si hideBtnOrdenes es true */}
                                {!hideBtnOrdenes && btnOrdenes}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}